import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AdminApp } from './admin/App';
import { PortalApp } from './portal/App';
import './styles.css';

/**
 * One bundle, two applications.
 *
 * They share components and a stylesheet and nothing else: separate routes,
 * separate API paths, separate session cookies, separate user tables on the
 * server. You never navigate from one to the other — they are different
 * audiences, not different tabs — so the panel is chosen once from the path
 * and each app owns its routes outright.
 *
 * The data-panel attribute swaps the palette, so a screenshot always says
 * which side of the system it came from.
 */
const isAdmin = window.location.pathname.startsWith('/admin');

document.documentElement.setAttribute('data-panel', isAdmin ? 'admin' : 'portal');
document.title = isAdmin ? 'WebForGrowth - Owner' : 'WebForGrowth - Customer portal';

if (!isAdmin && !window.location.pathname.startsWith('/portal')) {
  window.history.replaceState(null, '', '/portal');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>{isAdmin ? <AdminApp /> : <PortalApp />}</BrowserRouter>
  </StrictMode>,
);
